if (!customElements.get('section-tabs')) {
    customElements.define('section-tabs', class ThemeTab extends HTMLElement {
        constructor() {
            super();
            this.elements = {
                slider_element: this
            }
            this.initSlider();
        }

        open(button, tab) {


            const _target = button.closest('li');

            if (_target.classList.contains('active')) return;

            const _active = this.querySelector(`li.active`);
            const _activeTab = this.querySelector(`.tab__content-item.active`);
            const _targetTab = this.querySelector(`[data-tab-id="${tab}"]`);



            if(_active){
                _active.classList.remove('active');
            }
            if(_activeTab){
                _activeTab.classList.remove('active');
            }
            if(_target){
                _target.classList.add('active');
            }
            if(_targetTab){
                _targetTab.classList.add('active');
            }
            const sliderCurrent = _targetTab.querySelector('.tab__gallery .images')

            if(sliderCurrent){
                var flkty = new Flickity(sliderCurrent, {
                    prevNextButtons: true,
                    pageDots: false,
                    contain: true,groupCells: true
                });
                flkty.resize()
            }
        }

        initSlider() {
            let sectionSlider = this.elements.slider_element.querySelectorAll('.tab__content-item.active .images');
            // Initialize sliders
            sectionSlider.forEach(slider => {
                var flkty = new Flickity(slider, {
                    prevNextButtons: true,
                    pageDots: false,
                    contain: true,groupCells: true
                });
            });
        };

    });
}
